import { useMemo } from 'react';

import { Member } from '@/entities/vfo/types';

import { useIsFounder } from './useIsFounder';
import { usePermissions } from './usePermissions';

export const useIsMemberInPermission = (member: Member): boolean => {
  const { chatPermissions } = usePermissions();
  const isFounder = useIsFounder();

  return useMemo(() => {
    if (!chatPermissions || chatPermissions.canInitiateWithAll || isFounder) {
      return true;
    }

    const { allowedProfileIds = [], allowedTagCodes = [] } = chatPermissions;

    if (member.profileId && allowedProfileIds.includes(member.profileId)) {
      return true;
    }
    if (member.tag && allowedTagCodes.includes(member.tag)) {
      return true;
    }
    return false;
  }, [isFounder, chatPermissions]);
};
